import { DefaultTheme } from "styled-components"

const defaultTheme: DefaultTheme = {
  colors: {
    primary: "#522e3b",
    secondary: "#f5caca",
    accent: "#ae879a",
    base: "#615c60",
    background: "#fff",
    altBackground: "white",
  },
  defaultBorderRadius: "20px",
}

// const defaultTheme: DefaultTheme = {
//   colors: {
//     primary: "#932432",
//     secondary: "#3C1874",
//     accent: "#DE354C",
//     base: "#283747",
//     background: "#F3F3F3",
//     altBackground: "white",
//   },
//   defaultBorderRadius: "20px",
// }

// Grassy Green: #9bc400
//
// Purple Mountains Majesty: #8076a3
//
// Misty Mountain Pink: #f9c5bd
//
// Factory Stone Purple: #7c677f

// Deep Purple: #1d1145
//
// Trapper Keeper Green: #0db4b9
//
// Pink Boot: #f2a1a1
//
// Modern Pink Backpack: #e76d89
export { defaultTheme }
